export const buildGuestSendRouteState = ({
  reservation,
  threadId,
  message,
  clientMessageId,
  senderId,
  createdAt = new Date().toISOString(),
  knownMessageIds = [],
}) => {
  const guestReservation = reservation || {};
  const formattedPhone =
    guestReservation.formatted_phone || guestReservation.phone || "";
  const pendingMessage = {
    attachments: [],
    client_message_id: clientMessageId,
    content: message,
    created_at: createdAt,
    inbox_id: null,
    known_message_ids: knownMessageIds,
    message_id: null,
    sender_id: senderId ?? null,
    sender_type: "user",
    sid: "",
    status: "sent",
    thread_id: threadId,
  };
  const activeThread = {
    id: threadId,
    contact_category: null,
    current_reservation_count: 1,
    formatted_guest_phone: formattedPhone,
    guest_first_name: guestReservation.first_name || "",
    guest_last_name: guestReservation.last_name || "",
    last_message_on: createdAt,
    last_msg: message,
    last_msg_type: "u",
    meta_values: [],
    sources: [],
    unit_code: guestReservation.unit_code || guestReservation.pms_id || "",
  };

  return {
    source: "guest-send",
    activeThread,
    pendingMessage,
    threadDetail: {
      id: threadId,
      thread_id: threadId,
      guest_id: guestReservation.guest_id || null,
      guest: {
        first_name: guestReservation.first_name || "",
        last_name: guestReservation.last_name || "",
        formatted_phone: formattedPhone,
      },
      guest_reservations: [guestReservation],
      messages: [pendingMessage],
      sources: [],
    },
  };
};
